import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({searchValue, setSearchValue, data, searchKeys, onSearch, placeholder = "Search..." }) => {


  const filterData = (value) => {
    return data.filter((item) =>
      searchKeys.some((key) =>
        item[key]?.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleInputChange = (event, value, reason) => {
    setSearchValue(value);

    if (value === "") {
      onSearch(data); // Reset to full data when cleared
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      const filtered = searchValue ? filterData(searchValue) : data;
      onSearch(filtered);
      event.preventDefault(); // Prevent input from being cleared
    }
  };

  const handleOptionSelect = (event, newValue) => {
    if (newValue) {
      const label = typeof newValue === "string"
        ? newValue
        : getOptionLabel(newValue);
      setSearchValue(label);
      onSearch(filterData(label));
    }
  };

  const getOptionLabel = (option) => {
    if (typeof option === "string") return option;
    const key = searchKeys[0];
    return option[key] || "";
  };

  return (
    <Autocomplete
      freeSolo
      options={filterData(searchValue)}
      getOptionLabel={getOptionLabel}
      inputValue={searchValue}
      onInputChange={handleInputChange}
      onChange={handleOptionSelect}
      filterOptions={(x) => x}
      clearOnBlur={false}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          sx={{
            bgcolor: "#343a40",
            input: { color: "#fff" },
            borderRadius: 1,
            width: 250,
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "#6c757d" },
              "&:hover fieldset": { borderColor: "#adb5bd" },
              "&.Mui-focused fieldset": { borderColor: "#90caf9" }
            }
          }}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                <IconButton edge="start" size="small">
                  <SearchIcon sx={{ color: "#fff" }} />
                </IconButton>
              </InputAdornment>
            )
          }}
        />
      )}
    />
  );
};

export default SearchBar;
